import { Pipe, PipeTransform } from '@angular/core';
import { UserSaleGroup } from 'src/app/core/model/user/user-sale-group';

@Pipe({
  name: 'showRevenueIcon',
})
export class ShowRevenueIconPipe implements PipeTransform {
  transform(value: UserSaleGroup): boolean {
    let show = false;

    value.sales.forEach((sale) => {
      show =
        show ||
        (sale.isgServiceRevenue !== null && sale.isgServiceRevenue > 0) ||
        (sale.idgServiceRevenue !== null && sale.idgServiceRevenue > 0);
    });

    return show;
  }
}
